import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Icon } from "../Icon";
import styles from "./RibbonBadge.module.scss";
export const TIERS_LIST = ["default", "silver", "gold", "black", "none"];
const BADGE_TIER_CLASS = {
    default: styles.defaultTheme,
    silver: styles.silverTheme,
    gold: styles.goldTheme,
    black: styles.blackTheme,
    none: styles.noneTheme,
};
export const RibbonBadge = ({ tier = "default", icon, className, text, iconTestId, dataTestId, }) => {
    return (_jsxs("div", { className: classNames(styles.ribbonBadge, BADGE_TIER_CLASS[tier], className), "data-testid": dataTestId, children: [icon && _jsx(Icon, { height: "32px", width: "32px", component: icon, className: styles.icon, dataTestId: iconTestId }), text && (_jsx("div", { className: styles.badgeText, "data-testid": "badgeText", children: text }))] }));
};
//# sourceMappingURL=RibbonBadge.js.map